import React, { useState, useEffect } from 'react';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import NavigationMainMenuSubComponent from './NavigationMainMenuSubComponent';
import './style.scss';


const NavigationMainMenuDesktop = ({ items }) => {
  const [modalOpen, setModalOpen] = useState(false);

  let windowClickEventListener;

  /**
   * On window click, check if the modal is open, and the target does not contain the navigation menu class, if so close the modal and remove te event listener
   * @param {ClickEvent} event
   */
  const onWindowClick = (event) => {
    if (modalOpen &&
        event.target &&
        (!event.target.className || (event.target.className && event.target.className.indexOf('LegacyNavigationMainMenuDesktop__items') === -1))) {
      setModalOpen(false);
      window.removeEventListener('click', onWindowClick);
      windowClickEventListener = null;
    }
  };

  /**
   * Create a window event listener if it does not yet exist
   */
  const createWindowClickEventListener = () => {
    if (!windowClickEventListener) {
      windowClickEventListener = window.addEventListener('click', onWindowClick);
    }
  };

  useEffect(() => {
    document.body.style.overflow = modalOpen ? 'hidden' : 'unset';

    // If the modal is open, add an event listener to the window to close it on outside clicks
    if (modalOpen) {
      createWindowClickEventListener();
    }
  }, [modalOpen]);

  return (
    <ul className="LegacyNavigationMainMenuDesktop__items">
      {items.map((item) => {
        const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
        const href = item.getIn(['link', 'url'], '');
        const title = item.getIn(['link', 'title'], 'Untitled');

        return (
          <li
            key={`menu--main--menu-item-${title}:${href}`}
            className={`menu--main--menu-item ${modalOpen ? 'modalOpen' : ''}`}
          >
            <div className="LegacyNavigationMainMenuDesktop__title">
              {/* Link (currently not used) */}
              {href && (
                <CoreLink
                  to={href}
                  target={attrs.get('target')}
                >
                  {title}
                </CoreLink>
              )}
              {/* Button (currently the only option used) */}
              {!href && (
                <button
                  className="LegacyNavigationMainMenuDesktop__button"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setModalOpen((x) => !x);
                  }}
                >
                  {title}
                  {modalOpen ? <div className="icon icon-cross" /> : <div className="icon icon-hamburger" />}
                </button>
              )}
            </div>
            <NavigationMainMenuSubComponent item={item} />
          </li>
        );
      })}
    </ul>
  );
};

export default NavigationMainMenuDesktop;
